import React, { useState, useEffect, Fragment } from "react";
import {
  Row,
  Col,
  CardBody,
  Label,
  Card,
  FormFeedback,
  Input,
  Table
} from "reactstrap";
import Select from "react-select";
import i18n from "../../../i18n";
import SimpleAlertError from "../../../components/Alerts/SimpleAlertError";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { getOrgsAdmin } from "../../../helpers/api_rombo_helper";
import { getSubAdminsCostCenter, postUsersAdminCreate, getUsersAdmin } from "../../../helpers/api_rombo_helper";
import PaginationV2 from "../../../components/Pagination/PaginationV2";

const Step1 = ({ step, setStep, setName, setPhone, setEmail, name, phone, email, token, setLastName, lastName, setSecondLastName, secondLastName, setCompany, company, setIsRole, isRole, setInfoUser, infoUser }) => {

  const dispatch = useDispatch()
  const [emailValid, setEmailValid] = useState(false);
  const [phoneValid, setPhoneValid] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [showAddSubAdminForm, setShowAddSubAdminForm] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState(null);
  const [listCompanies, setListCompanies] = useState([]);
  const [listTypeUser, setTypeUser] = useState([]);
  const [subAdmins, setSubAdmins] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [subAdminsPage, setSubAdminsPage] = useState(1);
  const [selectedUsersPage, setSelectedUsersPage] = useState(1);
  const [totalSubAdmins, setTotalSubAdmins] = useState(0);
  const [searchName, setSearchName] = useState('');
  const itemsPerPage = 5;
  const [partnerId, setPartnerId] = useState(null);

  useEffect(() => {
    onGetOrgsAdmin();
    formatTypeUser();
    fillCompany();
  }, [dispatch]);

  useEffect(() => {
    if (partnerId !== null) {
      fetchSubAdmins(subAdminsPage, searchName);
    }
  }, [partnerId, subAdminsPage, searchName]);
  

  useEffect(() => {
    const storedPartnerId = localStorage.getItem('selectedPartnerId');
    if (storedPartnerId) {
      setPartnerId(parseInt(storedPartnerId));
    }
  }, []);  

  const handleSelectUser = (user) => {
    setSubAdmins(subAdmins.filter((subAdmin) => subAdmin.id !== user.id));
    const updatedSelectedUsers = [...selectedUsers, user];
    setSelectedUsers(updatedSelectedUsers);
    localStorage.setItem("selectedUsers", JSON.stringify(updatedSelectedUsers));
  };
  
  const handleRemoveUser = (user) => {
    setSelectedUsers(selectedUsers.filter((selectedUser) => selectedUser.id !== user.id));
    setSubAdmins([...subAdmins, user]);
  };
  
  const getPaginatedSubAdmins = () => {
    return subAdmins;
  };
  
  const getPaginatedSelectedUsers = () => {
    const start = (selectedUsersPage - 1) * itemsPerPage;
    return selectedUsers.slice(start, start + itemsPerPage);
  };  

  const onGetOrgsAdmin = () => {
    let partnersInfo = [];
    getOrgsAdmin(token)
      .then((response) => {
        response.map((item) => {
          partnersInfo.push({ label: item.name, value: item.partner_id});
        });
        setListCompanies([...partnersInfo]);
      })
      .catch((error) => {
        console.error("Error - onGetOrgsAdmin - ", error);
        setErrorAlert(true);
        setErrorAlertMessage((error?.response?.data?.detail || error.message));
      });
  };

  const opts = {
    partner_id: partnerId,
    page: subAdminsPage,
    size: itemsPerPage,
  };

  const fetchSubAdmins = (page = 1, nameFilter = '') => {
    setLoading(true);
    getUsersAdmin(token, { ...opts, page, name: nameFilter })
      .then((response) => {
        setSubAdmins(response.items);
        setTotalSubAdmins(response.total);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error getting subadmins:", error);
        setLoading(false);
      });
  };  

  const fetchSelectedUsers = (page = selectedUsersPage) => {
    const start = (page - 1) * itemsPerPage;
    const paginatedUsers = selectedUsers.slice(start, start + itemsPerPage);
    setSelectedUsers(paginatedUsers);
  };

  const handleAddNewUser = async () => {
    if (name && email) {
      const newUser = {
        id: Date.now(),
        name,
        lastName,
        email,
      };
  
      const body = {
        full_name: name,
        email: email,
        phone: phone,
        partner_name: "",
        is_staff: false,
        is_customer_admin: true,
        is_customer_user: false,
      };
  
      if (infoUser.is_staff) {
        body.partner_id = String(partnerId);
      }
  
      try {
        const createdUser = await postUsersAdminCreate(token, body);
  
        if (createdUser?.id) {
          const response = await getUsersAdmin(token, {
            full_name: name,
            email: email,
            partner_id: partnerId,
            page: 1,
            size: 1,
          });
  
          const userFromBackend = response?.items?.find(
            (user) => user.email === email && user.name === name
          );
  
          if (userFromBackend?.id) {
            newUser.id = userFromBackend.id;
          }
  
          const updatedSelectedUsers = [...selectedUsers, newUser];
          setSelectedUsers(updatedSelectedUsers);
  
          localStorage.setItem("selectedUsers", JSON.stringify(updatedSelectedUsers));
  
          setName("");
          setLastName("");
          setSecondLastName("");
          setEmail("");
          setPhone("");
          setShowAddSubAdminForm(false);
        }
      } catch (error) {
        console.error("Error - postUsersAdminCreate - ", error);
        setErrorAlertMessage(
          (JSON.stringify(error.response?.data?.detail) || error.message) ||
            i18n.t("ServerError")
        );
        setErrorAlert(true);
      }
    } else {
      setErrorAlertMessage(i18n.t("PleaseFillAllFields"));
      setErrorAlert(true);
    }
  };

  useEffect(() => {
    if (partnerId !== null) {
      fetchSubAdmins();
    }
  }, [partnerId]);  

  const fillCompany = () => {
    if (!infoUser.is_staff && infoUser.partner_name && infoUser.partner_id) {
      setCompany({ label: infoUser.partner_name, value: infoUser.partner_id });
    }
  };
  
  const formatTypeUser = () => {
    let arr = []
    arr.push({ label: i18n.t("IsSubAdmin"), value: "SUBADMIN" })
    setTypeUser([...arr])
  };

  const onClickNextStep = () => {
    if (isValidToProceed()) {
      setErrorAlertMessage(null);
      setErrorAlert(false);
      setStep(step + 1);
    } else {
      setErrorAlertMessage(i18n.t("PleaseSelectAtLeastOneUser"));
      setErrorAlert(true);
    }
  };

  const onBlurPhone = (newPhone) => {
    if (!newPhone.match('[0-9]{10}')) {
      setPhoneValid(true);
    } else {
      setPhoneValid(false);
      setPhone(newPhone);
    }
  };

  const onBlurEmail = (newEmail) => {
    if (!newEmail.match(/.+@.+\..+/)) {
      setEmailValid(true);
    } else {
      setEmailValid(false);
      setEmail(newEmail);
    }
  };

  const isValidToProceed = () => {
    return selectedUsers.length > 0;
  };

  return (
    <Fragment>
      <CardBody>
        <SimpleAlertError
          errorAlert={errorAlert}
          setErrorAlert={setErrorAlert}
          text={errorAlertMessage}
        />
        <Row>
          {infoUser.is_staff && ( 
            <Col xxl={6} md={6} xs={12}>
              <h6 className="employees-form-title" htmlFor="companyNameInput">{i18n.t("SelectingOrCreatingUser")}</h6>
              <p className="employees-form-text">{i18n.t("SubtituleSelectSubAdmin")}</p>
              <div className="request-separator margin-separator" />
            </Col>
          )}
          {!showAddSubAdminForm && (
            <Row>
              <Col xs={12} lg={6} className="pb-3">
               <h6 className="employees-form-title">{i18n.t("PreviouslyRegisteredUsers")}</h6>
                <p className="employees-form-text">{i18n.t("SelectAPreviouslyRegisteredUser")}</p>
                <Input
                  id="searchUser"
                  type="text"
                  value={searchName}
                  placeholder={i18n.t("UserName")}
                  className="search-user-name"
                  onChange={(e) => {
                    const value = e.target.value;
                    setSearchName(value);
                    setSubAdminsPage(1);
                    fetchSubAdmins(1, value);
                  }}
                />
              </Col>
              <Col xs={12} lg={6} className="pb-3">
                <h6 className="employees-form-title">{i18n.t("SelectedUsers")}</h6>
                <p className="employees-form-text">{i18n.t("SelectedSubadminUsers")}</p>
              </Col>
            </Row>
          )}
          {!showAddSubAdminForm && (
            <Row>
              <Col xs={6} xxl={6} xl={12} className="pb-3">
                <Table className="table table-responsive border">
                  <thead>
                    <tr>
                      <th className="bg-light">{i18n.t("Name")}</th>
                      <th className="bg-light">{i18n.t("Email")}</th>
                      <th className="bg-light">{i18n.t("Action")}</th>
                   </tr>
                  </thead>
                  <tbody>
                    {getPaginatedSubAdmins().map((subAdmin) => (
                      <tr key={subAdmin.id}>
                        <td>{subAdmin.full_name}</td>
                        <td>{subAdmin.email}</td>
                        <td>
                          <button
                            className="btn btn-users fs-8"
                            onClick={() => handleSelectUser(subAdmin)}
                          >
                            {i18n.t("Select")}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <PaginationV2
                  currentPage={subAdminsPage}
                  pageSize={itemsPerPage}
                  totalItems={totalSubAdmins}
                  onChangePage={(page) => {
                    setSubAdminsPage(page);
                    fetchSubAdmins(page);
                  }}
                  isLoading={loading}
                />
              </Col>
              <Col xs={6} xxl={6} xl={12} className="pb-3">
                <Table className="table table-responsive border">
                  <thead>
                    <tr>
                      <th className="bg-light">{i18n.t("Name")}</th>
                      <th className="bg-light">{i18n.t("Email")}</th>
                      <th className="bg-light">{i18n.t("Action")}</th>
                    </tr>
                  </thead>
                  <tbody>
                  {getPaginatedSelectedUsers().map((user) => (
                    <tr key={user.id}>
                      <td>{user.full_name || user.name}</td>
                      <td>{user.email}</td>
                      <td>
                        <button
                          className="mdi mdi-delete font-size-18 text-danger centered-button"
                          onClick={() => handleRemoveUser(user)}
                        >
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
                </Table>
                {selectedUsers.length > itemsPerPage && (
                  <PaginationV2
                    currentPage={selectedUsersPage}
                    pageSize={itemsPerPage}
                    totalItems={selectedUsers.length}
                    onChangePage={(page) => {
                      setSelectedUsersPage(page);
                      fetchSelectedUsers(page);
                    }}
                    isLoading={loading}
                  />
                )}
              </Col>
            </Row>
          )}
          <Col xs={12} xxl={12} xl={12} className="pb-3">
            <Link
              className="add-scale-text"
              onClick={() => setShowAddSubAdminForm(!showAddSubAdminForm)}
            >
              <i className="bx bx-plus add-scale-icon" />
              {i18n.t("CreateANewUser")}
            </Link>
          </Col>
          {showAddSubAdminForm && (
            <>
              <Col xs={12} xxl={12} xl={12} className="">
                <h6 className="employees-form-title">{i18n.t("DataUser")}</h6>
                <p className="employees-form-text">{i18n.t("SelectedSubadminUsers")}</p>
              </Col>
              <Row>
                <Col xs={12} xxl={6} xl={4} className="">
                  <Label className="employees-form-subtitle" htmlFor="nameInput">
                    {i18n.t("DisplayName")}
                  </Label>  
                  <Input
                    type="text"
                    name="name"
                    value={name}
                    className="employees-form-input"
                    id="nameInput"
                    onChange={(e) => setName(e.target.value)}
                    placeholder={i18n.t("UserName")}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} xxl={3} xl={4} className="pt-2">
                  <Label className="employees-form-subtitle" htmlFor="emailInput">
                    {i18n.t("Email")}
                  </Label>  
                  <Input
                    type="email"
                    name="email"
                    defaultValue={email}
                    className="employees-form-input"
                    id="emailInput"
                    onBlur={(e) => onBlurEmail(e.target.value)}
                    placeholder={i18n.t("UserEmail")}
                  />
                  {emailValid && (
                    <FormFeedback type="invalid" className="error-message">
                      <i className="fa fa-exclamation-circle"></i>
                      {i18n.t("EmailInvalid")}
                    </FormFeedback>
                  )}
                </Col>
                <Col xs={12} xxl={3} xl={4} className="pt-2">
                  <Label className="employees-form-subtitle" htmlFor="phoneInput">
                    {i18n.t("Phone")}
                  </Label>  
                  <Input
                    type="text"
                    name="phone"
                    defaultValue={phone}
                    className="employees-form-input"
                    id="phoneInput"
                    minLength={10}
                    maxLength={10}
                    onBlur={(e) => onBlurPhone(e.target.value)}
                    placeholder={i18n.t("UserPhone")}
                  />
                  {phoneValid && (
                    <FormFeedback type="invalid" className="error-message">
                      <i className="fa fa-exclamation-circle"></i>
                      {i18n.t("PhoneInvalid")}
                    </FormFeedback>
                  )}
                </Col>
              </Row>
              <Col xs={12} xxl={6} xl={4} className="">
                <div className="request-separator" />
              </Col>
              <Col xxl={12} md={4} xs={4} />
              {infoUser.is_staff && (
                <Col xxl={4} md={4} xs={12} className="pt-2">
                  <h6 className="employees-form-title">{i18n.t("TypeUser")}</h6>
                  <p className="employees-form-text single-line-text">{i18n.t("DescTypeUser")}</p>
                  <Card>
                    <Select
                      name="typeUser"
                      placeholder={i18n.t("NotAssigned")}
                      options={listTypeUser}
                      className="select2-selection"
                      value={listTypeUser.filter((item) => item.value == isRole )}
                      onChange={(e) => setIsRole(e.value)}
                      isDisabled={true}
                    />
                  </Card>
                </Col>
              )}
            </>
          )}
          <Row>
            <Col xs={12} xxl={6} xl={4} className="">
              <div className="request-separator" />
            </Col>
          </Row>
          <Col xxl={12} md={12} xs={12} className="pt-3 d-flex">
            <button
              onClick={showAddSubAdminForm ? handleAddNewUser : onClickNextStep}
              className="btn btn-request"
            >
              {showAddSubAdminForm ? i18n.t("UserCreate") : i18n.t("NextStep")}
            </button>
            <Link to={"/cost-centers"} className="btn btn-go-back mx-2">
              {i18n.t("Back")}
            </Link>
          </Col>
        </Row>
      </CardBody>
    </Fragment>
  )
}

export default Step1;
